import { useEffect, useState } from 'react'

import s from '../App.module.scss'

const useLockScroll = (): {
  enableScroll: () => void
  disableScroll: () => void
} => {
  const [isScrollEnabled, setIsScrollEnabled] = useState(true)

  const enableScroll = () => {
    setIsScrollEnabled(true)
  }

  const disableScroll = () => {
    setIsScrollEnabled(false)
  }

  useEffect(() => {
    isScrollEnabled
      ? document.documentElement.classList.remove(s.lockscroll)
      : document.documentElement.classList.add(s.lockscroll)
    return () => document.documentElement.classList.remove(s.lockscroll)
  }, [isScrollEnabled])

  return { enableScroll, disableScroll }
}

export default useLockScroll
